import React from 'react';
import { IonButton } from '@ionic/react';
import { useSwiper } from 'swiper/react';
import { useIsNative } from '../utils/useIsNative';
import { WelcomeSlide } from './WelcomeSlide';
import { SlideHeading } from './SlideHeading';
import { SlideActions } from './SlideActions';
import { SlideButton } from './SlideButton';
import { IDoneHandler } from './WelcomeTypes';

export const CARE_TOGETHER_SLIDE_HEADING = 'Care Together';

interface ICareTogetherSlideProps {
    isLastSlide: boolean;
    onDone: IDoneHandler;
}

export const CareTogetherSlide: React.FC<ICareTogetherSlideProps> = ({ isLastSlide, onDone }) => {
    const swiper = useSwiper();
    const isNative = useIsNative();

    return (
        <WelcomeSlide image="5-care.webp">
            <SlideHeading
                title={CARE_TOGETHER_SLIDE_HEADING}
                description={<>Keep everyone in the loop with<br/>community updates and <b>share the</b><br/><b>care load</b> with task management.</>}
            />
            <SlideActions>
                {!isNative &&
                    <IonButton fill="clear" type="button" onClick={() => swiper.slidePrev()}>&lt; Back</IonButton>
                }
                {isLastSlide ? (
                    <SlideButton onClick={() => onDone({ hide: true, trackingFrom: 'Continue' })}>Continue</SlideButton>
                ) : (
                    <SlideButton onClick={() => swiper.slideNext()}>Continue</SlideButton>
                )}
            </SlideActions>
        </WelcomeSlide>
    );
};
